import { useEffect, useState } from "react";
import api from "../api";

/**
 * Whether customer refund requests are switched on: the parent panel Billing → Refunds tab
 * and the admin Billing & Transactions → Refund Requests tab.
 *
 * The only switch is the backend's REFUND_CUSTOMER_REQUESTS_ENABLED, sent as
 * `refund_requests_enabled` by /public/site-settings. Off (only admins refund; customers
 * email support) until that call says otherwise; a failed lookup keeps it hidden.
 */
export default function useRefundRequestsEnabled() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api
      // site-settings is browser-cacheable for 60s; the timestamp makes this read fresh so
      // flipping the backend switch shows up on the next page load.
      .get("public/site-settings", { params: { _: Date.now() } })
      .then((res) => {
        if (!cancelled) setEnabled(Boolean(res.data?.data?.refund_requests_enabled));
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return enabled;
}
